<template>
  <v-dialog
    width="800"
    v-model="opened"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @keydown.esc="$emit('update:opened', false)"
    scrollable
  >
    <v-card>
      <v-card-title class="title py-4">
        <v-layout align-start> Add automation </v-layout>
      </v-card-title>

      <v-card-text class="py-5">
        <div class="text-xs-left">
          <div class="automation-container">
            <div class="automation-title">Who</div>
            <div class="automation-content">
              <v-select
                :items="clientSelections"
                label="Select target"
              ></v-select>
            </div>
          </div>

          <div class="vertical-line" />

          <div class="automation-container">
            <div class="automation-title">When</div>
            <div class="automation-content">
              <v-select
                :items="conditionSelections"
                label="Select condition"
              ></v-select>
            </div>
          </div>

          <div class="vertical-line" />

          <div class="automation-container">
            <div class="automation-title">Then...</div>

            <div class="automation-content">
              <v-select
                :items="actionSelections"
                item-value="value"
                item-text="text"
                label="Select action"
                v-model="selectedAction"
              ></v-select>

              <v-textarea
                v-if="selectedAction === 'create-todo-task'"
                outline
                label="Task description"
                placeholder="For example, send a message to {client.name} ."
                hide-details
              ></v-textarea>

              <v-combobox
                v-if="selectedAction === 'create-todo-task'"
                class="tags"
                label="Enter tags (press Enter to insert tags)"
                chips
                small-chips
                outline
                hide-details
              />

              <v-checkbox
                v-if="selectedAction === 'create-todo-task'"
                label="Mark this task as urgent"
              />
            </div>
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="actions-container">
        <v-spacer />
        <v-btn
          flat
          class="text-capitalize"
          @click="$emit('update:opened', false)"
        >
          Cancel
        </v-btn>
        <v-btn
          class="text-capitalize"
          color="primary"
          @click="$emit('update:opened', false)"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    opened: {
      type: Boolean,
    },
  },

  data() {
    return {
      clientSelections: [
        'Clients that are assigned to me',
        'Clients to whom I subscribed.',
      ],

      conditionSelections: [
        'They signed the Engagement letter.',
        'They completed the questionnaire.',
        'They completed the questionnaire and paid the payment.',
        'They uploaded documents in Soraban.',
        'They changed the name of the documents in Soraban.',
      ],

      actionSelections: [
        {
          value: 'create-todo-task',
          text: 'Create a to-do task.',
        },
        {
          value: 'notify-me-via-email',
          text: 'Send a notification to my email.',
        },
      ],

      selectedAction: null,
    };
  },
};
</script>

<style lang="postcss" scoped>
.title {
  font-weight: bold;
  letter-spacing: 0px !important;
  border-bottom: 1px solid #ddd;
}

.automation-container {
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0 0 0 / 15%);
  max-width: 600px;
  margin: 0px auto;
  align-self: stretch;
}

.automation-title {
  padding: 16px;
  font-weight: bold;
  border-radius: 8px 8px 0 0;
  font-size: 16px;
  color: #545454;
  background-color: #f3f3f6;
  border-bottom: 1px solid #ccc;
}

.automation-content {
  padding: 20px;

  .v-select {
    margin-top: 0;
  }

  .tags {
    margin-top: 16px;
  }

  & >>> .v-textarea .v-input__slot,
  & >>> .tags .v-input__slot {
    border-width: 1px;
    border-color: #ccc;
  }

  & >>> .v-textarea .v-input__slot:hover,
  & >>> .tags .v-input__slot:hover {
    border-width: 1px !important;
  }
}

.vertical-line {
  width: 1px;
  background-color: #ccc;
  margin: 0 auto;
  height: 36px;
}

.actions-container {
  border-top: 1px solid #ddd;
}
</style>
